import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-element-menu-dash',
  standalone: false,
  templateUrl: './element-menu-dash.component.html',
  styleUrl: './element-menu-dash.component.scss'
})
export class ElementMenuDashComponent {

  @Input() value = '';
  @Input() path = '';
  @Input() icon = '';
  @Output() menuClick = new EventEmitter<{ path: string[] }>();
  @Input() active = '';
  @Input() type: 'button' | 'switch' = 'button';
  /** Muestra candado visual; el click sigue funcionando (guard redirige a /plan). */
  @Input() locked = false;

  @Input() subItems: { value: string, path: string[], icon?: string }[] = [];
  expanded = false;

  navigate() {
    if (this.subItems.length > 0) {
      this.expanded = !this.expanded;
    } else {
      this.menuClick.emit({ path: [this.path] });
    }
  }

  navigateSub(path: string[]) {
    this.menuClick.emit({ path: path });
  }

  isActive(path: string[]) {
    return this.active === path[path.length - 1];
  }
}
